import PropTypes from "prop-types";

// eslint-disable-next-line import/prefer-default-export
export const StoreListItem = {
  type: PropTypes.shape({
    distance: PropTypes.number.isRequired,
    fullAddress: PropTypes.string.isRequired,
    hours: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        closeHour: PropTypes.string,
        openHour: PropTypes.string
      })
    ).isRequired,
    message: PropTypes.string,
    specialHours: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string,
        closeHour: PropTypes.string,
        openHour: PropTypes.string,
        description: PropTypes.string
      })
    ),
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    storeType: PropTypes.string.isRequired,
    storeLocatorAmenities: PropTypes.shape({
      footwear: PropTypes.bool,
      hasMirror: PropTypes.bool,
      personalShopping: PropTypes.bool,
      likeNew: PropTypes.bool,
      buyOnlinePickupStore: PropTypes.bool,
      curbsidePickup: PropTypes.bool,
      complementaryHemming: PropTypes.bool,
      returnsExchange: PropTypes.bool
    })
  }),
  defaults: {
    distance: 0,
    fullAddress: "",
    hours: [],
    message: "",
    specialHours: [],
    name: "",
    slug: "",
    storeType: ""
  }
};

export const StoreList = {
  type: PropTypes.arrayOf(StoreListItem.type),
  defaults: []
};
